import { ContainerPadding, CTA, Text, TextAlignment, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { useCallback, useEffect } from 'react';
import { CloseLayerCTA } from '../../components/cta/close-layer-cta';
import { ConsentimientosEnvioSection } from '../../components/inputs-group/consentimientos-envio-section';
import { DatosPersonalesInputsGroup } from '../../components/inputs-group/datos-personales-inputs-group';
import { VehicleSection } from '../../components/inputs-group/inputs/vehicle-section/vehicle-section';
import { LegalesSection } from '../../components/inputs-group/legales-section';
import { Section } from '../../components/screen/section';
import { ThankyouScreen } from '../../components/screen/thankyou';
import { useApp } from '../../contexts/app-context';
import { ndpsEntity } from '../../entities/ndps-entity';
import { personEntity } from '../../entities/person-entity';
import { vehicleEntity } from '../../entities/vehicle-entity';
import { isComerciales } from '../../helpers/carline-helpers';
import { setProductData } from '../../service/product-data';

export const ProspectVentaForm = () => {
	const { setAppThankyouScreen } = useApp();

	const getFormData = useCallback(() => {
		const ndpsToken = isComerciales() ? '' : 'VW_DDB_FRM_PROSPECT_LAUNCH';
		ndpsEntity.setToken(ndpsToken);

		return {
			'headers[DPS_TOKEN]': ndpsToken,

			'flags[PERSON_RGPD_ADAPTED]': true,
			'flags[FLAG_RELACION_MARCA_SIN_IC]': false,

			'fields[PERSON_TREATMENT]': isComerciales() ? personEntity.treatment : undefined,
			'fields[PERSON_NAME]': personEntity.name,
			'fields[PERSON_SURNAME_1]': personEntity.surname,
			'fields[PERSON_SURNAME_2]': personEntity.secondSurname,
			'fields[PERSON_EMAIL]': personEntity.email,
			'fields[PERSON_POSTAL_CP]': isComerciales() ? personEntity.postalCode : undefined,

			// PRODUCT DATA (cada data sobreescribe valores del anterior)
			...ndpsEntity.vehicleData,
		};
	}, []);

	const Form = () => (
		<>
			<VehicleSection paddingBottom={ContainerPadding.static515} />

			<Section paddingBottom={ContainerPadding.static515}>
				<Text bold appearance={TokenTextAppearance.headline200}>
					¿Cómo nos ponemos en contacto contigo?
				</Text>
				<Text appearance={TokenTextAppearance.copy200}>
					El responsable de los datos de contacto y preferencias que nos proporciones será Volkswagen Group España
					Distribución, S.A.U., que los compartirá con el concesionario que hayas seleccionado, con el fin de que este
					pueda dar respuesta a tu solicitud. El concesionario tratará tus datos personales como encargado del
					tratamiento.
				</Text>
				<DatosPersonalesInputsGroup hideTelefono hideCodigoPostal />
			</Section>

			<ConsentimientosEnvioSection formData={getFormData} showComunicacionesComerciales />
			<LegalesSection />
		</>
	);

	const CustomThankyou = () => {
		const ctasThankyouScreen = [
			vehicleEntity.showroomUrl ? (
				<CTA tag="a" href={vehicleEntity.showroomUrl} emphasis="primary">
					Conócelo
				</CTA>
			) : null,
			<CloseLayerCTA label="Seguir navegando" />,
		];
		return (
			<ThankyouScreen
				title={
					<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center} bold>
						¡Listo!
					</Text>
				}
				text={
					<Text appearance={TokenTextAppearance.copy100} textAlign={TextAlignment.center}>
						Muy pronto, recibirás toda la información sobre el {vehicleEntity.carlineTitle || 'Volkswagen'}.
					</Text>
				}
				ctas={ctasThankyouScreen}
			/>
		);
	};

	useEffect(() => {
		//setAppLoading(true);
		setAppThankyouScreen(<CustomThankyou />);

		setProductData().then(() => {
			//setAppLoading(false);
		});
	}, []);

	return Form();
};
